
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coachnet-renters",
      function () {
        return require("private-next-pages/coachnet-renters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coachnet-renters"])
      });
    }
  